import React from 'react';
import { FormInput, Segment, Divider } from 'semantic-ui-react';
import HelpButton from './HelpButton';

let context = require('../mp3du_context.json');

/*
Props has:
  onChange (func)
  value (object)
*/

class ShapefileInput extends React.Component {
  handleUpdate = this.handleUpdate.bind(this);

  handleUpdate(e,d) {
    const value = d.value;
    // Replace d.value with current Shapefile Object passed through props
    d.value = this.props.value === undefined ? {"SHAPEFILE": {}} : this.props.value;
    // Add/Update changed value
    d.value["SHAPEFILE"][d.name] = value;
    // Replace name
    d.name = "PARTICLE_START_LOCATIONS";
    this.props.onChange(e,d);
  }

  getDefault(obj,name) {
    return obj[name] === undefined ? "" : obj[name];
  }

  render() {
    const current = this.props.value === undefined ? {} : this.props.value["SHAPEFILE"];
    return(
      <Segment attached>
          <FormInput label="Shapefile File Name" name="FILE_NAME"
                     value={this.getDefault(current,'FILE_NAME')}
                     onChange={this.handleUpdate}/>

          <FormInput label="Cell ID Attribute" inline
                     name="CELLID_ATTR" className='inlineFine'
                     value={this.getDefault(current,"CELLID_ATTR")}
                     onChange={this.handleUpdate} className='inlineFine'/>
          <HelpButton hint={context['SHAPEFILE_CELLID_ATTR']} />
          <Divider hidden className='thinMan' />

          <FormInput label="Time Attribute" inline
                     name="TIME_ATTR" className='inlineFine'
                     value={this.getDefault(current,"TIME_ATTR")}
                     onChange={this.handleUpdate}/>
          <HelpButton hint={context['SHAPEFILE_TIME_ATTR']} />
          <Divider hidden className='thinMan' />

          <FormInput label="Z-Location Attribute" inline
                     name="ZLOC_ATTR" className='inlineFine'
                     value={this.getDefault(current,"ZLOC_ATTR")}
                     onChange={this.handleUpdate}/>
          <HelpButton hint={context['SHAPEFILE_ZLOC_ATTR']} />
          <Divider hidden className='thinMan' />

      </Segment>
    )
  }
}

export default ShapefileInput;